// This file is generated by scripts/generate-build-info.js.
const buildInfo = {
  "name": "Alfin Contacto",
  "version": "1.1.0",
  "buildDate": "2026-07-02T03:36:49.914Z"
};

export default buildInfo;
